import React from "react";
import Icon from "antd/lib/icon";

const Concept = () => {
  return (
    <div>
      <p className="step-p">
        Thank you for learning about blockchain!
      </p>
      <p className="step-p">
        If you liked this project, <a href="https://www.producthunt.com/posts/blockchain-demo-2-0-2"  rel="noopener noreferrer" target="_blank">vote on Product Hunt!</a>
      </p>
      
      <p style={{fontWeight: "500", letterSpacing: "1px"}}>Appreciate your support <Icon type="smile-o"/></p>
      <p className="step-p" style={{fontSize: "10pt"}}>
        <p>
          <b>BTC: </b>3EzxVHHhMMG9yN16DuFHKZwQgXjb68xjAe
        </p>
        <p>
          <b>BCH: </b>19JB8zYgFcgKu88NHFyqaktYQFVfQ1eUGx
        </p>
        <p>
          <b>ETH: </b>0xb0a3700d0f68c87c2aff0224285e67586b6b103b
        </p>
        <p>
          <b>LTC: </b>LRgwigkSE4dfVFsawDCWdNHGYs2SKdWzGN
        </p>
      </p>
    </div>
  );
};

export default Concept;



// WEBPACK FOOTER //
// ./src/steps/thats-it/concept.js